export default "__VITE_ASSET__7c0b19ea__"